import React from "react";

export default function Title({ title, desc, color }) {
  return (
    <div className="main__title">
      <h2 style={{ color: color }}>{title}</h2>
      {desc && (
        <p
          style={{ color: color }}
          dangerouslySetInnerHTML={{ __html: desc }}
        ></p>
      )}
    </div>
  );
}
